import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useLoaderVisibility, useLoading } from '@frontend-shared/loading'

export default function GlobalLoader() {
  const { t } = useTranslation()
  const { isLoading, isBlocking, operations } = useLoading()

  const progressVisible = useLoaderVisibility({ active: isLoading })
  const overlayVisible = useLoaderVisibility({ active: isBlocking, showDelayMs: 120, minVisibleMs: 320 })

  const latestOperation = operations[operations.length - 1]
  const blockingOperation = useMemo(
    () => [...operations].reverse().find((operation) => operation.blocking),
    [operations]
  )

  const inlineLabel = latestOperation?.label || t('common.loading')
  const blockingLabel = blockingOperation?.label || t('common.processing')

  return (
    <>
      <div
        className={`cn-global-progress${progressVisible ? ' is-visible' : ''}`}
        aria-hidden={!progressVisible}
      >
        <div className="cn-global-progress__bar" />
      </div>
      <div
        className={`cn-global-status${progressVisible ? ' is-visible' : ''}`}
        role="status"
        aria-live="polite"
      >
        <span className="cn-global-status__dot" />
        <span>{inlineLabel}</span>
      </div>
      {overlayVisible ? (
        <div className="cn-global-overlay" role="alertdialog" aria-modal="true" aria-live="assertive">
          <div className="cn-global-overlay__card">
            <div className="cn-global-overlay__spinner" aria-hidden="true" />
            <div className="cn-global-overlay__eyebrow">CargoNice</div>
            <div className="cn-global-overlay__label">{blockingLabel}</div>
          </div>
        </div>
      ) : null}
    </>
  )
}
